<template>
  <div class="card" v-show="currentCardId == 'requests'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>希望内容を入力</h2>
        <p>学部学科・勤務地・希望職種などの希望を入力します</p>
      </div>
      <div class="card-content" style="text-align: center">
        <div class="edit-form-item">
          <div class="item-name">学部・学科</div>
          <div class="item-body">
            <el-select
              v-model="formatData.department"
              placeholder="選択してください"
            >
              <el-option
                v-for="item in departmentOptions"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
        </div>
        <div class="edit-form-item">
          <div class="item-name">希望業界</div>
          <div class="item-body">
            <el-select
              v-model="formatData.hopeIndustry"
              placeholder="選択してください"
            >
              <el-option
                v-for="item in hopeIndustryOptions"
                :key="item"
                :label="item"
                :style="item"
                :value="item"
              />
            </el-select>
          </div>
          <div class="item-name">希望職種</div>
          <div class="item-body">
            <el-select
              v-model="formatData.hopeJobcategory"
              placeholder="選択してください"
            >
              <el-option
                v-for="item in hopeJobcategoryOptions"
                :key="item"
                :label="item"
                :style="item"
                :value="item"
              />
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import departmentOptions from '@/utils/format-edit/departmentOptions.json'
import hopeIndustryOptions from '@/utils/format-edit/hopeIndustryOptions.json'
import hopeJobcategoryOptions from '@/utils/format-edit/hopeJobcategoryOptions.json'
import { useNewYagiofferFormatData } from '@/composables/format-edit/useNewYagiofferFormat'

defineProps<{
  currentCardId?: string
}>()

const formatData = useNewYagiofferFormatData()
</script>
